import { Component, OnInit, Optional, Inject, Input } from '@angular/core';
import { INavigationService, PershingTranslationService } from '@pershing/pershing-core';
import { NxiNavigation } from '@pershing/nxi-common';
import { Location } from '@angular/common';
import { NavigationBaseComponent } from './navigation-base.component';

@Component({
    selector: 'ada-navigation',
    templateUrl: 'ada-nav.component.html'
})
export class ADANavComponent extends NavigationBaseComponent implements OnInit {
    menuItems: any[];
    showPostLogin: boolean = true;
    showLogout: boolean = false;
    isSSOLogoutHide: boolean = false;
    isCBOL: boolean = false;
    @Input() isAdaTheme: boolean;
    parent: any;
    child: any;
    constructor(
        protected navigationService: INavigationService,
        protected location: Location,
        private translationService: PershingTranslationService,
        @Optional() @Inject('AppSettings') appSettings: any
    ) {
        super(navigationService, location, appSettings);
        this.showLogout = appSettings.isLoggedIn;
        this.linkUrl = appSettings.postLoginEquiptUrl;
        this.isSSOLogoutHide = appSettings.isSSOLogoutHide;
        this.isCBOL = appSettings.isCBOL;
        this.translationService.addTranslationFolder('@pershing/nxi-navigation', 'node_modules/@pershing/nxi-navigation/lib');
    }

    ngOnInit() {
        super.ngOnInit();
        this.navigationService.getParentPage().subscribe(
            (data: any) => {
                this.parent = data;
                if (this.menuItems) {
                    this.menuItems.forEach(ele => {
                        if (ele.id === data.id && ele.children.length > 0) {
                            ele.flag = true;
                        }
                    });
                }
            }
        );
        this.navigationService.getChildPage().subscribe(
            (data: any) => this.child = data
        );
    }

    handleNavigation(parentpage: any): void {
        let parentId = this.parent ? this.parent.id : '';
        if (parentpage.children.length === 0) {
            let navigation = new NxiNavigation();
            navigation.parentPage = parentpage;
            this.parent = parentpage;
            this.navigationService.handleNavigation(navigation);
            this.menuItems.forEach(ele => {
                ele.flag = false;
            });
        } else if (parentpage.id !== parentId) {
            parentpage.flag = !parentpage.flag;
        }
    }

    handleChildNavigation(parentpage: any, childPage: any): void {
        let navigation = new NxiNavigation();
        navigation.parentPage = parentpage;
        navigation.childPage = childPage;
        this.parent = parentpage;
        this.child = childPage;
        this.navigationService.handleNavigation(navigation);
        this.menuItems.forEach(ele => {
            if (ele.id === parentpage.id) {
                ele.flag = true;
            } else {
                ele.flag = false;
            }
        });
    }
    logout(): void {
        document.dispatchEvent(new CustomEvent('portal.LogoutEvent'));
    }

    processMenuItems() {
        this.menuItems.forEach(ele => {
            if (ele.id === 'tools') {
                ele = this.handleRemoveMenu(ele);
            }
            if (ele.children.length === 0) {
                ele.haschildren = false;
                ele.flag = true;
            } else if (ele.children.length > 0) {
                ele.haschildren = true;
                ele.flag = false;
            }
        });
    }
    handleNavigationLink(parentpage: any): void {
        if (parentpage.id === 'equipt') {
            window.location.href = parentpage.LinkUrl;
        } else {
            window.open(parentpage.LinkUrl);
        }
        return;
    }
    handleRemoveMenu(data: any) {
        if (data.children.length > 0) {
            let finPlanID = 'financialplanning';
            if (data.children.filter(item => finPlanID === item.id).length > 0
                && !!sessionStorage.getItem('rmvFinPlan') && sessionStorage.getItem('rmvFinPlan') === 'Y') {
                data.children = data.children.filter(item => !finPlanID.includes(item.id));
                return data;
            }
        }
        return data;
    }
}
